<div class="back">
  <a
      (click)="goBack()"
      style="display: inline-flex; align-items: center"
    >
      <mat-icon
        style="font-size: 16px; display: inline-flex; align-items: center"
        >arrow_back</mat-icon
      >
      <span>Back</span></a
    >
</div>
<div class="main-logo">
  <div class="banner-box">
    <div class="banner-content">
      <span class="welcome-text"
        >Welcome back to, {{ quarter }} Credit risk review {{ year }}
      </span>
      <h1>{{ client_name }}</h1>
      <h3>Track and manage all of your borrowers request in one place.</h3>
    </div>
  </div>
</div>
<div class="motif-container">
  <div class="motif-row">
    <div
      class="motif-col-xs-12 motif-col-sm-12 motif-col-md-12 motif-col-lg-12"
    >
      <div class="tab-header" style="display: flex; align-items: center; justify-content: space-between;">
        <div style="display: flex; align-items: center; gap: 8px;">
          View Documents
          <span *ngIf="pdfUrl" style="font-size: 15px; font-weight: 400; color: #fff; background: #1976d2 !important; border-radius: 6px; padding: 4px 10px; margin-left: 8px; border: 1px solid #7660ff; display: inline-flex; align-items: center; gap: 8px;">
            <span style="font-family: EYInterstate !important; font-weight: 400; margin-bottom: 2px;">: {{ documentName }}</span>
          </span>
        </div>
        <button motifButton type="button" size="small" placement="top" class="update-results-primary"
          style="margin-right: 0;width: 100px; height: 44px; display: flex; align-items: center;" [loading]="false"
          variant="null" aria-label="Upload document" 
          (click)="$event.preventDefault(); $event.stopPropagation(); onUploadClick(null, $event)">
          Upload Document
          <motif-icon class="upload-btn" [iconFunction]="iconoirCloudUpload"></motif-icon>
        </button>
      </div>
    </div>
  </div>
  <motif-progress-loader
    [show]="IsLoader"
    [fullScreen]="true"
  ></motif-progress-loader>
  <div class="motif-row mb-4" style="margin-bottom: 5rem">
    <div class="motif-col-lg-5 motif-col iframe-container" *ngIf="pdfUrl" style="position: relative;">
      <button (click)="closePdf()" style="color: white; position: absolute; top: 20px; right: 3px; z-index: 10; background: black; border: none; font-size: 1rem; cursor: pointer; width: 24px; height: 24px; border-radius: 50%; box-shadow: 0 1px 4px rgba(0,0,0,0.15); display: flex; align-items: center; justify-content: center;">&times;</button>
      <iframe *ngIf="pdfUrl" [src]="pdfUrl" style="width: 96%; height: 900px; border: none;"></iframe>
    </div>
    <div [class]="colFortable + ' motif-col'">
      <div style="position: relative; width: 100%; border: 1px solid #7660ff; border-radius: 8px;">
      <motif-table #motifTable
        [columnDefs]="columnDefs"
        [rowData]="dataSource"
        width="100%"
        height="100%"
        [pagination]="true"
        [paginationPageSize]="pagesize"
        cellClass="truncate-cell"
      ></motif-table>
      <ng-template #activeInactiveTemplate let-row>
        <mat-slide-toggle
            [checked]="row.active === true"
            (change)="toggleActive(row)"
            color="primary"
            class="small-toggle"
            [motif-tooltip]="row.active ? 'Deactivate Document' : 'Activate Document'"
          >
            <span *ngIf="row.active"></span>
            <span *ngIf="!row.active"></span>
          </mat-slide-toggle>
      </ng-template>
        <div style="font-family: EYInterstate; position: absolute; left: 0; bottom: 0; padding: 8px 0 8px 8px; z-index: 2; background: transparent; pointer-events: none; font-size: 14px;margin-bottom: 10px;margin-left: 14px;">
          <span *ngIf="dataSource && dataSource.length > 0">
            Total items: {{ dataSource.length }}
          </span>
          <span *ngIf="!dataSource || dataSource.length === 0">
            No entries
          </span>
        </div>
      </div>
<!-- Custom cell templates for tooltips on Doc Id, File Name, Chunk Count -->
<ng-template #docIdTemplate let-row>
  <ng-container *ngIf="row.doc_id_present; else missingDocId">
    <span [motif-tooltip]="row.doc_id" placement="top">{{ row.doc_id }}</span>
  </ng-container>
</ng-template>
<ng-template #missingDocId>
  <span class="status-pill" style="background:#ffe6e6; color:#b00020; border:1px solid #b00020;">Missing Doc id</span>
</ng-template>
<ng-template #docCategoryTemplate let-row>
  <div style="display: flex; flex-direction: column; gap: 6px;">
    <span [motif-tooltip]="row.doc_classification" placement="top" class="truncate-cell">{{ row.doc_classification }}</span>
  </div>
</ng-template>
<ng-template #fileNameTemplate let-row>
  <div style="display:flex; align-items:center; gap:8px;">
    <ng-container *ngIf="row.filename_present; else missingFilename">
      <span [motif-tooltip]="row.original_filename" placement="top" class="status-pill" style="border: 1px solid #7660ff !important;">{{ row.original_filename }}</span>
    </ng-container>
    <ng-template #missingFilename>
      <span class="status-pill" style="background:#ffe6e6; color:#b00020; border:1px solid #b00020;">Missing File Name</span>
    </ng-template>
  </div>
</ng-template>
    </div>
  </div>
</div>

<ng-template #actionsTemplate let-row="$implicit">
  <motif-button-group role="group">
    <button
      motifButton
      size="large"
      (click)="showDoc(row)"
      [disabled]="row.sas_url === null || row.sas_url === ''"
      [motif-tooltip]="'View Document'"
      placement="top"
      style="border: none; padding: 0px; background: none;"
    >
      <motif-icon
        [iconFunction]="motifActionIcFindInPage24px"
        class="view-docs-large-icon"
        aria-hidden="false"
      >
      </motif-icon>
    </button>
  </motif-button-group>
</ng-template>

<ng-template #statusTemplate let-row="$implicit">
  <ng-container *ngIf="row.doc_status_present; else missingDocStatus">
    <span
      [ngClass]="{
        'status-completed': row.classification_indexing_step.status?.toLowerCase() === 'completed',
        'status-partial': row.classification_indexing_step.status?.toLowerCase() === 'partial_completed' || row.classification_indexing_step.status?.toLowerCase() === 'partial',
        'status-failed': row.classification_indexing_step.status?.toLowerCase() === 'failed',
        'status-inprogress': row.classification_indexing_step.status?.toLowerCase() === 'in_progress' || row.classification_indexing_step.status?.toLowerCase() === 'pending' || row.classification_indexing_step.status?.toLowerCase() === 'inprogress',
        'status-incomplete': row.classification_indexing_step.status?.toLowerCase() === 'in_complete' || row.classification_indexing_step.status?.toLowerCase() === 'incomplete' || row.classification_indexing_step.status?.toLowerCase() === 'in complete',
        'status-skipped': row.classification_indexing_step.status?.toLowerCase() === 'skipped'
      }"
      [motif-tooltip]="formatStatus(row.classification_indexing_step?.status)"
      placement="top"
      class="status-pill truncate-cell"
    >
      {{ formatStatus(row.classification_indexing_step?.status) }}
    </span>
  </ng-container>
  <ng-template #missingDocStatus>
    <span class="status-pill" style="background:#f0f0f0; color:#666; border:1px solid #ccc;">Missing Status</span>
</ng-template>
</ng-template>
<ng-template #aiClassified let-row="$implicit">
  <div style="position: relative" class="_view-docs-select">
    <div *ngIf="selectedDocId !== row.doc_id">
      <span class="clickable truncate-cell" [motif-tooltip]="row.doc_classification" placement="top"> {{ row.doc_classification }}</span>
      <motif-icon
        style="margin-left: 9px;"
        [iconFunction]="iconEdit"
        (click)="row.isEditable && editAiClassified(row.doc_id, row.doc_classification)"
        [ngClass]="{ 'disabled-motif-button': !row.isEditable }"
        [style.cursor]="!row.isEditable ? 'not-allowed' : 'pointer'"
        [attr.aria-disabled]="!row.isEditable"
        [motif-tooltip]="row.isEditable ? 'Edit Classification' : 'Editing disabled for Non-PDF/Excel files'"
        placement="top"
      ></motif-icon>
    </div>
    <div
      *ngIf="selectedDocId === row.doc_id"
      style="display: flex; align-items: center"
    >
      <motif-select
        [(ngModel)]="row.doc_classification"
        (ngModelChange)="OpenconfirmationModal(row.doc_classification)"
        [disabled]="isDocCategoryDisabled(row) || selectedDocId !== row.doc_id"
        [ngClass]="{ 'disabled-motif-button': isDocCategoryDisabled(row) || selectedDocId !== row.doc_id }"
        placeholder="Select Classification"
      >
        <motif-option
          *ngFor="let item of classifiedDropdown"
          [value]="item.document_category"
        >
          {{ item.document_category }}
        </motif-option>
      </motif-select>
<!--       <motif-icon
        style="margin-left: 1px; cursor: pointer"
        [iconFunction]="saveIcon"
        (click)="updateAiClassified(row.doc_classification, row.doc_id)"
        [ngClass]="{ 'disabled-motif-button': selectedDocId !== row.doc_id }"
      >
      </motif-icon> -->
    </div>
  </div>
</ng-template>

<div id="myModal" class="modal" *ngIf="confirmationModal">
  <!-- Modal content -->
  <div class="modal-content">
    <div class="motif-row" style="margin-bottom: 3rem">
      <div class="motif-col-lg-12" style="text-align: center">
        <label for="dependentElement" class="asset-label">
          Confirm AI Classified Doc Category Change
        </label>
        <span
          class="close"
          (click)="confirmationModal = false"
          style="margin-left: auto"
          >&times;</span
        >
      </div>
      <div
        class="motif-col-lg-12"
        style="margin-top: 3rem; display: flex; justify-content: center"
      >
        <button
          motifButton
          color="primary"
          size="medium"
          (click)="updateAiClassified(new_label, selectedDocId)"
        >
          Save
        </button>
      </div>
    </div>
  </div>
</div>
<div *ngIf="isUploadModalOpen"
  style="position:fixed; inset:0; display:flex; align-items:center; justify-content:center; z-index:2000;">
  <div style="position: absolute; inset:0; background: rgba(0,0,0,0.45);"></div>
  <div role="dialog" aria-modal="true"
    style="position:relative; background:#fff; width:460px; max-width:94%; border-radius:8px; padding:20px; box-shadow:0 10px 30px rgba(0,0,0,0.3); z-index:2001;">
    <button aria-label="Close" (click)="closeUploadModal()"
      style="position:absolute; right:8px; top:8px; border:none; background:transparent; font-size:20px; cursor:pointer;">&times;</button>
    <div
      style="margin-top: 0; margin-bottom: 8px; font-size: 16px; font-weight: bold; font-family: EYInterstate; display:flex; align-items:center; gap:8px; flex-direction:column; align-items:flex-start;">
      <div style="display:flex; align-items:center; gap:8px; width:100%; justify-content:space-between;">
        <span>Upload Repayment Analysis Excel Document</span>
      </div>
      <div role="note" aria-live="polite" style="margin-top:8px; width:100%; background:#fff6f6; border:1px solid #f5c6cb; color:#8a1f23; padding:10px; border-radius:6px; font-size:13px;">
        <strong>Warning:</strong> Uploading a new file will replace the existing repayment analysis.
      </div>
    </div>
    <div class="upload-dashed-container">
      <div class="upload-dashed-inner">
        <input type="file" #fileInput style="display:none" accept=".xls,.xlsx"
          (change)="onUploadFileSelected($event)" />
        <button motifButton type="button" size="medium" class="upload-select-btn" (click)="fileInput.click()"
          aria-label="Choose Excel file">
          <motif-icon [iconFunction]="iconoirCloudUpload" class="modal-cloud-icon"></motif-icon>
        </button>
      </div>
      <div *ngIf="uploadSelectedFile" class="selected-file-row">
        <span class="selected-file-pill" [title]="uploadSelectedFile.name">{{ uploadSelectedFile.name }}</span>
        <button type="button" class="remove-file-btn" (click)="clearSelectedFile()"
          aria-label="Remove selected file">&times;</button>
      </div>
      <div *ngIf="!uploadSelectedFile" class="upload-warning-box" role="note" aria-live="polite">
        <p style="margin:0; color:#444;">Select a Single Excel file (.xls or .xlsx).
        </p>
      </div>
    </div>
    <div style="display:flex; justify-content:flex-end; gap:8px; margin-top:12px;">
      <button motifButton size="medium" color="secondary" (click)="closeUploadModal()">Cancel</button>
      <button motifButton size="medium" color="primary" [disabled]="!uploadSelectedFile || isUploadingFile"
        (click)="uploadSubmit()">
        <span *ngIf="!isUploadingFile">Upload</span>
        <span *ngIf="isUploadingFile">Uploading...</span>
      </button>
    </div>
  </div>
</div>
